export default "__VITE_ASSET__CZvgsu24__"